"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.RightSide = exports.LeftSide = exports.Content = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ec636p03"
} : {
  target: "ec636p03",
  label: "Wrapper"
})("display:flex;flex-direction:row;width:100%;justify-content:space-between;@media screen and (max-width: ", _breakpoints.default.small, "){flex-direction:column;text-align:center;}");
const Content = exports.Content = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ec636p02"
} : {
  target: "ec636p02",
  label: "Content"
})();
const LeftSide = exports.LeftSide = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ec636p01"
} : {
  target: "ec636p01",
  label: "LeftSide"
})(process.env.NODE_ENV === "production" ? {
  name: "16exalf",
  styles: "display:grid;grid-row-gap:0.5em;h1,h2,h3,h4,h5{align-self:center;}"
} : {
  name: "16exalf",
  styles: "display:grid;grid-row-gap:0.5em;h1,h2,h3,h4,h5{align-self:center;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const RightSide = exports.RightSide = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ec636p00"
} : {
  target: "ec636p00",
  label: "RightSide"
})("margin-left:2em;display:flex;align-items:center;@media screen and (max-width: ", _breakpoints.default.small, "){margin-left:0;margin-top:2em;align-self:center;}button,a{min-width:169px;}");